// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Dialog__dialog-container-f22eaf {
  position: relative;
  padding: 24px;
  width: 424px;
  max-width: 100%;
  border-radius: 24px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  background-color: var(--base-10);
}

.Dialog__title-c4c801 {
  color: var(--base-110);
  font: var(--font-body-2);
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 16px;
}

.Dialog__text-d4c07e {
  color: var(--base-110);
  font: var(--font-body-4);
  width: 100%;
  margin-bottom: 24px;
}

.Dialog__action-panel-d69818 {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.Dialog__button-fdee61 {
  margin-inline-start: 8px;
}

.Dialog__checkbox-c9d7da {
  display: flex;
  cursor: pointer;
  margin-top: 16px;
  margin-bottom: 24px;
}

.Dialog__checkbox-input-b6917d {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
}

.Dialog__checkbox-view-c397c3 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  margin-inline-end: 8px;
  margin-top: 2px;
  border-radius: 4px;
  border: 2px solid var(--base-60);
  box-sizing: border-box;
}

.Dialog__checkbox-text-ff43dc {
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  color: var(--base-110);
}

.Dialog__selected-b1f6bd {
  border: none;
  background-color: var(--brand-primary-40);
}

.Dialog__secondaryButton-ec6c1f:hover {
  background-color: var(--base-30);
}

.Dialog__close-button-b7e38e {
  position: absolute;
  top: 10px;
  inset-inline-end: 10px;
}

.Dialog__has-close-button-e1ef5e .Dialog__title-c4c801 {
  padding-inline-end: 30px;
}

.Dialog__has-close-button-e1ef5e:not(.Dialog__has-title-ce11c7) .Dialog__text-d4c07e {
  padding-inline-end: 20px;
  box-sizing: border-box;
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/Dialog/Dialog.styles.m.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,0CAAA;EACA,gCAAA;AACF;;AAEA;EACE,sBAAA;EACA,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AACF;;AAEA;EACE,sBAAA;EACA,wBAAA;EACA,WAAA;EACA,mBAAA;AACF;;AAEA;EACE,WAAA;EACA,aAAA;EACA,yBAAA;AACF;;AAEA;EACE,wBAAA;AACF;;AAEA;EACE,aAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gCAAA;EACA,sBAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,sBAAA;AACF;;AAEA;EACE,YAAA;EACA,yCAAA;AACF;;AAEA;EACE,gCAAA;AACF;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,sBAAA;AACF;;AAEA;EACE,wBAAA;AACF;;AAEA;EACE,wBAAA;EACA,sBAAA;AACF","sourcesContent":[".dialog-container {\n  position: relative;\n  padding: 24px;\n  width: 424px;\n  max-width: 100%;\n  border-radius: 24px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);\n  background-color: var(--base-10);\n}\n\n.title {\n  color: var(--base-110);\n  font: var(--font-body-2);\n  font-size: 20px;\n  font-weight: bold;\n  margin-bottom: 16px;\n}\n\n.text {\n  color: var(--base-110);\n  font: var(--font-body-4);\n  width: 100%;\n  margin-bottom: 24px;\n}\n\n.action-panel {\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.button {\n  margin-inline-start: 8px;\n}\n\n.checkbox {\n  display: flex;\n  cursor: pointer;\n  margin-top: 16px;\n  margin-bottom: 24px;\n}\n\n.checkbox-input {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  clip: rect(0 0 0 0);\n}\n\n.checkbox-view {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 20px;\n  height: 20px;\n  margin-inline-end: 8px;\n  margin-top: 2px;\n  border-radius: 4px;\n  border: 2px solid var(--base-60);\n  box-sizing: border-box;\n}\n\n.checkbox-text {\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  color: var(--base-110);\n}\n\n.selected {\n  border: none;\n  background-color: var(--brand-primary-40);\n}\n\n.secondaryButton:hover {\n  background-color: var(--base-30);\n}\n\n.close-button {\n  position: absolute;\n  top: 10px;\n  inset-inline-end: 10px;\n}\n\n.has-close-button .title {\n  padding-inline-end: 30px;\n}\n\n.has-close-button:not(.has-title) .text {\n  padding-inline-end: 20px;\n  box-sizing: border-box;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dialog-container": `Dialog__dialog-container-f22eaf`,
	"dialogContainer": `Dialog__dialog-container-f22eaf`,
	"title": `Dialog__title-c4c801`,
	"text": `Dialog__text-d4c07e`,
	"action-panel": `Dialog__action-panel-d69818`,
	"actionPanel": `Dialog__action-panel-d69818`,
	"button": `Dialog__button-fdee61`,
	"checkbox": `Dialog__checkbox-c9d7da`,
	"checkbox-input": `Dialog__checkbox-input-b6917d`,
	"checkboxInput": `Dialog__checkbox-input-b6917d`,
	"checkbox-view": `Dialog__checkbox-view-c397c3`,
	"checkboxView": `Dialog__checkbox-view-c397c3`,
	"checkbox-text": `Dialog__checkbox-text-ff43dc`,
	"checkboxText": `Dialog__checkbox-text-ff43dc`,
	"selected": `Dialog__selected-b1f6bd`,
	"secondaryButton": `Dialog__secondaryButton-ec6c1f`,
	"close-button": `Dialog__close-button-b7e38e`,
	"closeButton": `Dialog__close-button-b7e38e`,
	"has-close-button": `Dialog__has-close-button-e1ef5e`,
	"hasCloseButton": `Dialog__has-close-button-e1ef5e`,
	"has-title": `Dialog__has-title-ce11c7`,
	"hasTitle": `Dialog__has-title-ce11c7`
};
module.exports = ___CSS_LOADER_EXPORT___;
